import { render, staticRenderFns } from "./SendCouponShops.vue?vue&type=template&id=136a7033&scoped=true&"
import script from "./SendCouponShops.vue?vue&type=script&lang=js&"
export * from "./SendCouponShops.vue?vue&type=script&lang=js&"
import style0 from "./SendCouponShops.vue?vue&type=style&index=0&id=136a7033&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a7033",
  null
  
)

export default component.exports